import React, { useEffect, useRef, useState } from 'react';
import { isWeb } from '~global-screens';
import PropTypes from 'prop-types';

const Config = require('../../../../config/default.env').default;

export default function AdsenseParallax({
  adSlot,
  style = {},
  adFormat = 'fluid',
  adLayout = 'in-article',
  adLayoutKey = '',
}) {
  const adContainerRef = useRef(null);
  const adInsRef = useRef(null);
  const [showPlaceholder, setShowPlaceholder] = useState(true);

  const adId = useRef(
    `adsense-parallax-${adSlot}-${Math.random().toString(36).substring(2, 9)}`,
  ).current;

  useEffect(() => {
    if (!Config.GOOGLE_ADSENSE_ENABLED || Config.GOOGLE_ADSENSE_TEST_MODE) {
      setShowPlaceholder(true);
      return;
    }

    //this element
    const parentContainer = adContainerRef.current;
    const adInsElement = adInsRef.current;

    if (!parentContainer || !adInsElement) {
      return;
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.target === parentContainer &&
          mutation.attributeName === 'style'
        ) {
          parentContainer.style.height = isWeb ? '300px' : '250px';
        }
        if (
          mutation.type === 'attributes' &&
          mutation.target === adInsElement &&
          mutation.attributeName === 'data-ad-status'
        ) {
          const adStatus = adInsElement.getAttribute('data-ad-status');
          setShowPlaceholder(adStatus !== 'filled');
          parentContainer.style.height = 'auto !important';
          console.log('AdSense status changed for parallax ', adStatus);
        }
      });
    });

    observer.observe(parentContainer, {
      attributes: true,
      attributeFilter: ['style'],
    });
    observer.observe(adInsElement, {
      attributes: true,
      attributeFilter: ['data-ad-status'],
    });

    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error('AdSense push error:', e);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  if (!Config.GOOGLE_ADSENSE_ENABLED) {
    return null;
  }

  const adProps = {
    ref: adInsRef,
    key: adId,
    id: adId,
    className: 'adsbygoogle',
    style: {
      display: 'block',
      textAlign: 'center',
    },
    'data-ad-client': Config.GOOGLE_ADSENSE_PUBLISHER_ID,
    'data-ad-slot': adSlot,
    'data-ad-format': adFormat,
    'data-full-width-responsive': 'true',
  };

  if (adLayout) {
    adProps['data-ad-layout'] = adLayout;
  }
  if (adLayoutKey) {
    adProps['data-ad-layout-key'] = adLayoutKey;
  }

  const webStyles = {
    container: {
      ...style,
      width: '100%',
      height: '100%',
      position: 'relative',
      overflow: 'hidden',
    },
    placeholder: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f9f9f9',
    },
    placeholderText: {
      color: '#666',
      fontSize: '14px',
      fontFamily: 'Arial, sans-serif',
    },
    adWrapper: {
      width: '100%',
      height: '100%',
      position: 'relative',
      zIndex: 2,
    },
  };

  return (
    <div id="adsense-parallax" ref={adContainerRef} style={webStyles.container}>
      {showPlaceholder && (
        <div style={webStyles.placeholder}>
          <div style={webStyles.placeholderText}>Advertisement</div>
        </div>
      )}
      <div style={webStyles.adWrapper}>
        <ins {...adProps} />
      </div>
    </div>
  );
}

AdsenseParallax.propTypes = {
  adSlot: PropTypes.string.isRequired,
  style: PropTypes.object,
  adFormat: PropTypes.string,
  adLayout: PropTypes.string,
  adLayoutKey: PropTypes.string,
};
